import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from '../utils/localStorageHelper'

const resources = {
  en: {
    translation: {
      // admin portal
      "Camera {{n}}": "Camera {{n}}",
      "No cameras": "No cameras",
      "Parking area": "Parking area",
      "Plate sync": "Plate sync",
      "Passings import": "Passings import",
      "Remote access tunnels": "Remote access tunnels",
      "{{n}} plates not added": "{{n}} plates not added",
      "{{n}} deleted plates still active on the camera": "{{n}} deleted plates still active on the camera",
      "(failing for {{age}})": "(failing for {{age}})",
      "Health": "Health",
      "Errors": "Errors",
      "Warnings": "Warnings",
      "Sites without problems": "Sites without problems",
      "Workers running": "Workers running",
      "Problems": "Problems",
      "Show hints": "Show hints",
      "Refresh": "Refresh",
      "Everything is running smoothly.": "Everything is running smoothly.",
      "Updated {{time}} · refreshes every minute": "Updated {{time}} · refreshes every minute",
      "Background workers": "Background workers",
      "running": "running",
      "not responding": "not responding",
      "no heartbeat yet": "no heartbeat yet",
      "last heartbeat {{age}} ago": "last heartbeat {{age}} ago",
      "up {{age}}": "up {{age}}",
      "{{n}} cameras in error": "{{n}} cameras in error",
      "Workers report after the update is deployed and they have been restarted.": "Workers report after the update is deployed and they have been restarted.",
      "{{n}} s": "{{n}} s",
      "{{n}} min": "{{n}} min",
      "{{n}} h": "{{n}} h",
      "{{n}} d": "{{n}} d",
      "Teltonika has never connected": "Teltonika has never connected",
      "Teltonika offline for {{age}}": "Teltonika offline for {{age}}",
      "Special-plate rules not fetched for {{age}}": "Special-plate rules not fetched for {{age}}",
      "{{count}} plate syncs failed (oldest {{age}})": "{{count}} plate syncs failed (oldest {{age}})",
      "{{count}} plate syncs waiting for {{age}}": "{{count}} plate syncs waiting for {{age}}",
      "Camera is not assigned to a gate": "Camera is not assigned to a gate",
      "No passings for {{age}}": "No passings for {{age}}",
      "No passings in the last {{days}} days": "No passings in the last {{days}} days",
      "Proximity radius set but no position — app openings fail": "Proximity radius set but no position — app openings fail",
      "No camera and no Teltonika — gate cannot be opened": "No camera and no Teltonika — gate cannot be opened",
      "No Teltonika linked": "No Teltonika linked",
      "No position set": "No position set",
      "No problems": "No problems",
      "{{errors}} errors, {{warnings}} warnings": "{{errors}} errors, {{warnings}} warnings",
      "{{n}} problems at this site": "{{n}} problems at this site",
      "No problems at this site": "No problems at this site",
      "Hide hints": "Hide hints",
      "{{n}} hints": "{{n}} hints",
      "{{n}} problems": "{{n}} problems",
      "error": "error",
      "warning": "warning",
      "info": "info",
      "Parking": "Parking",
      "Parking (square)": "Parking (square)",
      "Underground garage": "Underground garage",
      "Multi-storey car park": "Multi-storey car park",
      "Underground": "Underground",
      "Car park": "Car park",
      "EV charging": "EV charging",
      "Accessible parking": "Accessible parking",
      "Staff / reserved": "Staff / reserved",
      "Secured area": "Secured area",
      "Construction": "Construction",
      "Logistics": "Logistics",
      "Bus / coach parking": "Bus / coach parking",
      "Park & Ride": "Park & Ride",
      "Bicycle": "Bicycle",
      "Airport": "Airport",
      "Petrol station": "Petrol station",
      "Building": "Building",
      "Multi-building": "Multi-building",
      "Office": "Office",
      "Conference centre": "Conference centre",
      "Public authority": "Public authority",
      "Retail": "Retail",
      "Supermarket": "Supermarket",
      "Restaurant / café": "Restaurant / café",
      "Hotel": "Hotel",
      "Residential": "Residential",
      "Hospital": "Hospital",
      "Medical centre": "Medical centre",
      "School / university": "School / university",
      "Sports venue": "Sports venue",
      "Sports field": "Sports field",
      "Event venue": "Event venue",
      "Concert hall": "Concert hall",
      "Cinema": "Cinema",
      "Park / nature": "Park / nature",
      "Lake / swimming pool": "Lake / swimming pool",
      "Tourism": "Tourism",
      "None": "None",
      "Pick on map": "Pick on map",
      "Hide map": "Hide map",
      "Clear position": "Clear position",
      "Address not found": "Address not found",
      "Address search is unavailable": "Address search is unavailable",
      "Search address…": "Search address…",
      "Search": "Search",
      "Click the map at the barrier, or drag the pin. The circle shows the proximity radius.": "Click the map at the barrier, or drag the pin. The circle shows the proximity radius.",
      "Name and address of the location": "Name and address of the location",
      "Parking areas, their barriers and the Teltonika behind them": "Parking areas, their barriers and the Teltonika behind them",
      "ANPR cameras per gate — test the connection before saving": "ANPR cameras per gate — test the connection before saving",
      "Check everything — nothing is saved before you confirm": "Check everything — nothing is saved before you confirm",
      "Remove": "Remove",
      "New camera": "New camera",
      "new": "new",
      "Plates to sync": "Plates to sync",
      "Everything checks out.": "Everything checks out.",
      "The browser blocked the camera window — please allow popups for this site.": "The browser blocked the camera window — please allow popups for this site.",
      "Close": "Close",
      "Remote session": "Remote session",
      "Show window": "Show window",
      "End session": "End session",
      "Open the camera's web interface through a temporary tunnel": "Open the camera's web interface through a temporary tunnel",
      "Camera on this Teltonika": "Camera on this Teltonika",
      "Camera {{n}} (port {{port}})": "Camera {{n}} (port {{port}})",
      "Enter a custom URL": "Enter a custom URL",
      "Pick Teltonika and camera instead": "Pick Teltonika and camera instead",
      "Link a Teltonika to a gate of this area first.": "Link a Teltonika to a gate of this area first.",
      "1 new site": "1 new site",
      "Add a gate first — cameras belong to a gate.": "Add a gate first — cameras belong to a gate.",
      "Add areas, gates, cameras": "Add areas, gates, cameras",
      "Add camera": "Add camera",
      "Add gate": "Add gate",
      "Add parking area": "Add parking area",
      "Add to site": "Add to site",
      "All": "All",
      "Areas & gates": "Areas & gates",
      "Assign a Teltonika to a sales partner so their admins can set it up at their own sites.": "Assign a Teltonika to a sales partner so their admins can set it up at their own sites.",
      "Back": "Back",
      "Camera": "Camera",
      "Checking…": "Checking…",
      "Comment": "Comment",
      "Create site": "Create site",
      "Extend {{name}}": "Extend {{name}}",
      "Linked to": "Linked to",
      "New gate": "New gate",
      "New parking area": "New parking area",
      "New parking areas, gates and cameras will be added to {{name}}. Existing ones stay unchanged — edit them on the site page.": "New parking areas, gates and cameras will be added to {{name}}. Existing ones stay unchanged — edit them on the site page.",
      "New site": "New site",
      "Next": "Next",
      "No partner assigned": "No partner assigned",
      "Not linked to a gate": "Not linked to a gate",
      "Not reachable": "Not reachable",
      "Please fix:": "Please fix:",
      "Reachable, but login failed": "Reachable, but login failed",
      "Reachable, login works": "Reachable, login works",
      "Recorded passings of new cameras start arriving within about an hour.": "Recorded passings of new cameras start arriving within about an hour.",
      "Remove camera": "Remove camera",
      "Remove gate": "Remove gate",
      "Review": "Review",
      "Routers": "Routers",
      "Search MAC, IP, site…": "Search MAC, IP, site…",
      "Setup": "Setup",
      "Status": "Status",
      "Test connection": "Test connection",
      "Testing…": "Testing…",
      "Unexpected response": "Unexpected response",
      "empty = global account": "empty = global account",
      "existing": "existing",
      "{{n}} existing cameras": "{{n}} existing cameras",
      "{{n}} license plates will be sent to the new cameras": "{{n}} license plates will be sent to the new cameras",
      "{{n}} new cameras": "{{n}} new cameras",
      "{{n}} new gates": "{{n}} new gates",
      "{{n}} new parking areas": "{{n}} new parking areas",
      "Administration": "Administration",
      "All sites": "All sites",
      "Back to dashboard": "Back to dashboard",
      "Camera URL": "Camera URL",
      "Camera password": "Camera password",
      "Camera username": "Camera username",
      "Cameras": "Cameras",
      "Cameras without a gate": "Cameras without a gate",
      "City": "City",
      "Code from the email": "Code from the email",
      "Confirm": "Confirm",
      "Could not send the code. Please try again.": "Could not send the code. Please try again.",
      "Delete permanently?": "Delete permanently?",
      "Empty = no GPS check for app openings. 50–5000 m.": "Empty = no GPS check for app openings. 50–5000 m.",
      "End admin session": "End admin session",
      "Entry": "Entry",
      "Exit": "Exit",
      "For your security, confirm it's you: we'll email a one-time code to your address.": "For your security, confirm it's you: we'll email a one-time code to your address.",
      "Gate": "Gate",
      "Gates of the same area may share one Teltonika.": "Gates of the same area may share one Teltonika.",
      "Invalid or expired code": "Invalid or expired code",
      "Last handshake: {{at}}": "Last handshake: {{at}}",
      "License plates": "License plates",
      "Loading…": "Loading…",
      "Moving a site to another partner changes who can administer it.": "Moving a site to another partner changes who can administer it.",
      "Must point to the Teltonika of this area (WireGuard address).": "Must point to the Teltonika of this area (WireGuard address).",
      "Never connected": "Never connected",
      "No Teltonika": "No Teltonika",
      "No Teltonika linked to a gate yet": "No Teltonika linked to a gate yet",
      "No gates in this area.": "No gates in this area.",
      "No partner": "No partner",
      "No router linked": "No router linked",
      "No sites found.": "No sites found.",
      "Opener": "Opener",
      "Opens the barrier": "Opens the barrier",
      "Parking areas": "Parking areas",
      "Partner admin": "Partner admin",
      "Plate sync records": "Plate sync records",
      "Platform admin": "Platform admin",
      "Recorded passings": "Recorded passings",
      "Relay": "Relay",
      "Remote access": "Remote access",
      "Remove stored credentials (use the global camera account)": "Remove stored credentials (use the global camera account)",
      "Resend code": "Resend code",
      "Resend in {{s}} s": "Resend in {{s}} s",
      "Sales partner": "Sales partner",
      "Saving…": "Saving…",
      "Search name, city, partner…": "Search name, city, partner…",
      "Send code": "Send code",
      "Session until {{time}}": "Session until {{time}}",
      "Site details": "Site details",
      "Sites": "Sites",
      "Skip plate sync": "Skip plate sync",
      "Street": "Street",
      "This cannot be undone.": "This cannot be undone.",
      "This gate still has cameras. Move them to another gate or delete them first.": "This gate still has cameras. Move them to another gate or delete them first.",
      "Timezone": "Timezone",
      "Type the name to confirm:": "Type the name to confirm:",
      "User access grants": "User access grants",
      "Your account has no administrator access.": "Your account has no administrator access.",
      "ZIP": "ZIP",
      "free": "free",
      "not set — global account": "not set — global account",
      "offline": "offline",
      "online": "online",
      "unchanged (set)": "unchanged (set)",
      "will be deleted together with:": "will be deleted together with:",
      "{{n}} failed syncs": "{{n}} failed syncs",
      "{{n}} pending": "{{n}} pending",
      "{{online}}/{{total}} online": "{{online}}/{{total}} online",
      "— no Teltonika —": "— no Teltonika —",
      "— no gate —": "— no gate —",
      "— none (ezentry only) —": "— none (ezentry only) —",
      "login": "Login",
      "select_area": "Select Area",
      "details": "Details",
      "date_from": "Date From",
      "date_to": "Date To",
      "edit": "Edit",
      "delete": "Delete",
      "add": "Add",
      "Expired": "Expired",
      "Home": "Home",
      "Area": "Area",
      "details_for_area": "Details for area",
      "Hide": "Hide",
      "Show": "Show",
      "Open Gate": "Open Gate",
      "Close Gate": "Close Gate",
      "Logged in as": "Logged in as",
      "Guest": "Guest",
      "Login": "Login",
      "Select Car Plate": "Select car plate",
      "Plate": "Plate",
      "Save": "Save",
      "Save_New_Plate": "Save new plate",
      "Logout": "Logout",
      "de": "German",
      "en": "English",
      "Save_success": "Saved successfully",
      "Delete_success": "Deleted successfully",
      "Cancel": "Cancel",
      "Delete": "Delete",
      "Confirm_Deletion": "Confirm Deletion",
      "Delete_question_user": "Remove access for",
      "Delete_question_plate": "Do you really want to delete plate",
      "Delete_question_user": "Do you really want to delete user",
      "Dashboard": "Dashboard",
      "Select Site": "Select site",
      "Loading sites...": "Loading sites...",
      "Licenses": "License Plates",
      "LoginText": "Please enter the code you received by email.",
      "Enter your email": "Enter your email",
      "add new": "new plate",
      "site_manager for area not allowed": "Role 'site_manager' not allowed for area.",
      "Please select an area for the user": "Please select an area for the user",
      "Please enter an email": "Please enter an email.",
      "Please enter a valid email address": "Please enter a valid email address.",
      "too_much_devices": "You are not allowed to log in on more than one device. Please contact your administrator.",
      "Search by name or email": "Search by name or email",
      "Detailed Statistics": "Detailed Statistics",
      "Statistic": "Statistic",
      "Showing plates per hour for every area.": "Showing plates per hour for every area.",
      "All areas": "All areas",
      "Statistics": "Statistics",
      "Open camera": "Open camera",
      "site_manager": "Site manager",
      "gate_opener": "Gate opener",
      "platform_admin": "Platform admin",
      "partner_admin": "Partner admin",
      // Gate control
      "no gates": "No gates",
      "no_cameras": "No cameras",
      "Select Camera": "Select Camera",
      "Tap to open": "Tap to open",
      "Opening...": "Opening...",
      "Opened": "Opened",
      "Error": "Error",
      "Retry": "Retry",
      "Open": "Open",
      "Getting location": "Getting location…",
      "Too far from gate": "Too far from gate",
      "Location unavailable": "Location unavailable",
      "Location access blocked": "Location access blocked",
      "Re-enable location hint": "Location requires HTTPS. If already on HTTPS: tap the lock icon → Site settings → Location → Allow",
      // Gate management
      "Gates": "Gates",
      "Proximity": "Require location to open",
      "No coordinates set": "⚠ No coordinates set — contact support to activate",
      "Proximity applies to gate openers only. Site managers can always open.": "Applies to manual opens only. Site managers can always open.",
      "Gate updated.": "Gate updated.",
      "Camera updated.": "Camera updated.",
      "Failed to update gate": "Failed to update gate",
      "Failed to update camera": "Failed to update camera",
      "Gate name": "Gate name",
      "Direction": "Direction",
      "entry": "Entry",
      "exit": "Exit",
      "Latitude": "Latitude",
      "Longitude": "Longitude",
      "Proximity radius (m)": "Proximity radius (m)",
      "Teltonika": "Teltonika",
      "Is opener": "Is opener",
      "No plate sync": "No plate sync",
      "opener": "opener",
      "no sync": "no sync",
      "sync_status_title": "Sync status",
      "deleted_still_active_title_one": "{{count}} deleted plate can still enter",
      "deleted_still_active_title_other": "{{count}} deleted plates can still enter",
      "deleted_still_active_hint": "The gate hasn't confirmed the removal yet (it is probably unreachable). We keep retrying automatically.",
      "sync_not_synced_one": "{{count}} plate not synced",
      "sync_not_synced_other": "{{count}} plates not synced",
      "last try": "last try",
      // Plate form
      "Valid From": "Valid From",
      "Valid Until": "Valid Until",
      "Note": "Note",
      "note_gdpr_hint": "Personal information in this field (e.g. names) is GDPR-relevant. Only add it if you have a legal basis.",
      "new_category": "Category",
      "Clear filters": "Clear filters",
      "search_plates_placeholder": "Search plates...",
      "No plates match your filter": "No plates match your filter",
      "no_plate_found_for": "No plate found for \"{{plate}}\".",
      "Add plate": "Add plate",
      "new_short": "New",
      "No plates in this area yet.": "No plates in this area yet.",
      "Add first plate": "Add first plate",
      // Statistics
      "Loading...": "Loading...",
      "Loading statistics...": "Loading statistics...",
      "Site Overview": "Site Overview",
      "Authorized": "Authorized",
      "Unauthorized": "Unauthorized",
      "Click for details": "Click for details",
      "click_hour_hint": "Click a bar on the chart to load details",
      "insights_title": "Insights",
      "insights_passings": "Passings",
      "insights_unique": "Unique Plates",
      "insights_peak_avg": "/ day in this hour",
      "day_abbr": "d",
      "insights_auth_rate": "Auth Rate",
      "insights_peak_hour": "Peak Hour",
      "insights_avg_day": "avg / day",
      "insights_typically_day": "typically / day",
      "insights_top_denied": "Top Denied",
      "insights_top_allowed": "Top Allowed",
      "insights_area_breakdown": "Area Breakdown",
      "insights_week": "Week",
      "insights_month": "Month",
      "insights_quick_add_title": "Add Plate",
      "insights_quick_add_note": "Note (optional)",
      "insights_quick_add_areas": "Add to areas",
      "insights_quick_add_success": "Plate added successfully",
      "insights_no_data": "No data for this period",
      "plate_already_exists": "This plate already exists in this area",
      "fuzzy_match_hint": "Possible match — camera read \"{{raw}}\", likely a misread",
      "pss_match_hint": "Opened automatically as a public safety service vehicle (police, Feuerwehr, ...) — not an enrolled plate",
      "export_csv": "Export CSV",
      "include_denied": "Include denied",
      "export_failed": "Export failed. Please try again.",
      "export_tab": "Export",
      "update_available": "A new version of ezentry is available.",
      "update_reload": "Reload",
      "update_later": "Later",
      "export_plates_title": "Plates",
      "export_plates_hint": "Download all plates of one area as a CSV file: plate, valid from, valid until, note, categories and date added. Multiple categories are separated by \" | \".",
      "export_select_area": "Select area…",
      "export_passings_title": "Passings (statistics)",
      "export_passings_hint": "Download the passings of your gates for a date range. You can also do this on the statistics page.",
      "export_range_hint": "Max. 1 year per export",
      // Areas / Details
      "Areas": "Areas",
      "Area name": "Area name",
      "Available spaces": "Available spaces",
      "spaces": "spaces",
      "Icon": "Icon",
      "No areas found.": "No areas found.",
      "Area updated.": "Area updated.",
      "Failed to update area": "Failed to update area",
      "No areas found for this site": "No areas found for this site",
      "Area not found": "Area not found",
      "Used": "Used",
      // User management
      "User Management": "User Management",
      "Email": "Email",
      "Name": "Name",
      "Enter email": "Enter email",
      "Enter user's name": "Enter user's name",
      "Role": "Role",
      "Scope": "Scope",
      "Site": "Site",
      "Creating...": "Creating...",
      "Grant Authorization": "Grant Authorization",
      "Existing Users": "Existing Users",
      "No users found": "No users found",
      // Login
      "Wrong code": "Wrong code",
      "Verification failed": "Verification failed",
      "Access denied": "Access denied",
      "Back to login": "Back to login",
      // Admin / Cameras
      "Select Area": "Select Area",
      "Select Gate": "Select Gate",
      "Edit site": "Edit site",
      "Add area": "Add area",
      "Edit area": "Edit area",
      // What's New modal
      "gdpr_title": "Privacy Information",
      "gdpr_link": "Privacy",
      "whats_new_title": "What's New",
      "whats_new_close": "Got it",

      "whats_new_1_8_title": "CSV Export & Bulk Delete",
      "whats_new_1_8_item1": "Export statistics as a CSV file for further analysis or reporting",
      "whats_new_1_8_item2": "Delete multiple plates at once — even a whole category like 'Expired'",
      "whats_new_1_8_item3": "Fixed duplicate plates caused by different formatting (e.g. W-1234A vs. W1234A), plus other bugfixes",
      "whats_new_1_8_item4": "Android App available in Google Play Store 'ezentry'",
      "whats_new_1_10_title": "More Icons, Deleted-Plate Warning & 24/7 Monitoring",
      "whats_new_1_10_item1": "More icons for parking areas — e.g. underground garage, multi-storey car park, sports venue, event venue, hotel",
      "whats_new_1_10_item2": "If a deleted plate is still active at a gate (e.g. because the gate was briefly unreachable), you now see it right away in the parking area",
      "whats_new_1_10_item3": "Round-the-clock monitoring: we're alerted automatically when a gate loses its connection and can react — often before you notice",
      "whats_new_1_9_title": "Bulk Edit, Sync Status & Special Plates",
      "whats_new_1_9_item1": "Edit multiple plates at once — e.g. change validity dates for all selected plates",
      "whats_new_1_9_item2": "New sync status shows whether plates have already been transferred to the gate",
      "whats_new_1_9_item3": "Special plates (e.g. police, ambulance, taxi) can be switched on or off per site in site settings",
      "whats_new_1_9_item4": "Stricter permission checks, CSV export that opens correctly in German Excel, and other bugfixes",
      "whats_new_1_9_item5": "Group your plate list by date added — see at a glance what was added today, this week or this month",

      "whats_new_1_7_title": "Gates, Insights & Design",
      "whats_new_1_7_item1": "Require GPS location to open gates — ensures barriers can only be triggered on-site",
      "whats_new_1_7_item2": "New Insights panel: weekly & monthly pass volume, peak hour, top allowed and denied plates, area breakdown",
      "whats_new_1_7_item3": "Refreshed visual design: clearer page/card hierarchy, improved dark mode",

      "whats_new_1_6_title": "Plate Management & Visuals",
      "whats_new_1_6_item1": "Sort and group license plates by category, expiry date, or plate number for easier tracking",
      "whats_new_1_6_item2": "Dark Mode: Choose between manual selection or automatic syncing with your system settings",
      "whats_new_1_6_item3": "Statistics details allow checking permitted and prohibited entries to your parking areas",

      "whats_new_1_5_title": "Site settings",
      "whats_new_1_5_item1": "Change area details (available spaces, name, icon)",
      "whats_new_1_5_item2": "Manage users on a site",
      "whats_new_1_5_item3": "Add, change, delete categories",

      "whats_new_1_4_title": "Custom Plate Categories",
      "whats_new_1_4_item1": "Add custom license plate categories per site.",
      "whats_new_1_4_item2": "Filter and group plates by category.",

      "whats_new_1_3_title": "Statistics",
      "whats_new_1_3_item1": "See blocked or allowed passing on your gates at a glance",
      "whats_new_1_3_item2": "Detailed statistics let you filter by area and check back the last 7 days",

      // Site settings / categories
      "Site settings": "Site settings",
      "Statistics details": "Statistics details",
      "Categories": "Categories",
      "Users": "Users",
      "Special Plates": "Special Plates",
      "Austria": "Austria",
      "pss_label_police": "Police (BP-)",
      "pss_label_firebrigade": "Fire brigade (FW-)",
      "pss_label_rettungsdienst": "Emergency medical services, Vienna (W-XXXX-RD / W-XXXX-MA)",
      "pss_label_taxi": "Taxi (…TX)",
      "pss_label_army": "Austrian Armed Forces (BH-)",
      "pss_label_post": "Austrian Post (PT-)",
      "Vehicles matching an enabled category open this site's gates automatically, without needing to be enrolled as a plate.": "Vehicles matching an enabled category open this site's gates automatically, without needing to be enrolled as a plate.",
      "Changes can take up to 30 minutes to reach the barrier.": "Changes can take up to 30 minutes to reach the barrier.",
      "No special plate categories available.": "No special plate categories available.",
      "Failed to load special plates.": "Failed to load special plates.",
      "Failed to update rule.": "Failed to update rule.",
      "New category name": "New category name",
      "No categories yet.": "No categories yet.",
      "plates": "plates",
      "Delete Category": "Delete Category",
      "Delete category": "Delete category",
      "This category is used for": "This category is used for",
      "Plates will not be deleted, only deassociated.": "Plates will not be deleted, only deassociated.",
      "Category updated.": "Category updated.",
      "Category created.": "Category created.",
      "Category deleted.": "Category deleted.",
      "Failed to update category": "Failed to update category",
      "Failed to create category": "Failed to create category",
      "Failed to delete category": "Failed to delete category",
      // User management (new strings)
      "Manage users": "Manage users",
      "User created successfully!": "User created successfully!",
      "Failed to load users": "Failed to load users",
      "Enter an email address and role to grant someone access to this site.": "Enter an email address and role to grant someone access to this site.",
      "I confirm I have the legal basis to add this person to the system.": "I confirm I have the legal basis to add this person to the system.",
      "Please confirm you have the legal basis to add this person.": "Please confirm you have the legal basis to add this person.",
      "Details carried over from the dashboard — review and click Grant Authorization to complete.": "Details carried over from the dashboard — review and click Grant Authorization to complete.",
      // User settings
      "Settings": "Settings",
      "Appearance": "Appearance",
      "theme_system": "System",
      "theme_light": "Light",
      "theme_dark": "Dark",
      // Plate sorting & grouping
      "sort_by": "Sort",
      "sort_plate": "A–Z",
      "sort_created": "Added",
      "sort_expiry": "Expiry",
      "view_group":         "Group",
      "group_by_category":  "By category",
      "group_by_expiry":    "By expiry",
      "group_by_added":     "By date added",
      "added_today":        "Added today",
      "added_last_7_days":  "Last 7 days",
      "added_last_30_days": "Last 30 days",
      "added_older":        "Older",
      "sync_filter_chip":   "Not synced",
      "sync_filter_hint":   "Show only plates that are not synced",
      "uncategorized":      "Uncategorized",
      "expiry_this_month":  "This month",
      "expiry_this_quarter":"This quarter",
      "expiry_later":       "Later",
      "expiry_never":       "No expiry",
      // Bulk plate selection
      "select_multiple": "Select multiple",
      "done_selecting": "Done selecting",
      "select_all_in_group": "Select all in this group",
      "deselect_all_in_group": "Deselect all in this group",
      "plates_selected_one": "{{count}} plate selected",
      "plates_selected_other": "{{count}} plates selected",
      "confirm_bulk_delete_one": "Delete this plate?",
      "confirm_bulk_delete_other": "Delete {{count}} plates?",
      "and_n_more_one": "…and {{count}} more",
      "and_n_more_other": "…and {{count}} more",
      "Delete_success_bulk_one": "Plate deleted",
      "Delete_success_bulk_other": "{{count}} plates deleted",
      "bulk_edit_title": "Edit dates",
      "bulk_edit_hint_one": "Choose which date to change for the selected plate. Only checked fields are updated.",
      "bulk_edit_hint_other": "Choose which date to change for all {{count}} selected plates. Only checked fields are updated.",
      "plates_updated_bulk_one": "Plate updated",
      "plates_updated_bulk_other": "{{count}} plates updated",
      "plates_skipped_invalid_range_one": "{{count}} plate skipped — new date would be before its other date: {{plates}}",
      "plates_skipped_invalid_range_other": "{{count}} plates skipped — new date would be before their other date: {{plates}}"
    }
  },
  de: {
    translation: {
      // admin portal
      "Camera {{n}}": "Kamera {{n}}",
      "No cameras": "Keine Kameras",
      "Parking area": "Parkbereich",
      "Plate sync": "Kennzeichen-Sync",
      "Passings import": "Durchfahrten-Import",
      "Remote access tunnels": "Fernzugriffs-Tunnel",
      "{{n}} plates not added": "{{n}} Kennzeichen nicht übertragen",
      "{{n}} deleted plates still active on the camera": "{{n}} gelöschte Kennzeichen noch an der Kamera aktiv",
      "(failing for {{age}})": "(seit {{age}} fehlgeschlagen)",
      "Health": "Zustand",
      "Errors": "Fehler",
      "Warnings": "Warnungen",
      "Sites without problems": "Standorte ohne Probleme",
      "Workers running": "Dienste aktiv",
      "Problems": "Probleme",
      "Show hints": "Hinweise anzeigen",
      "Refresh": "Aktualisieren",
      "Everything is running smoothly.": "Alles läuft rund.",
      "Updated {{time}} · refreshes every minute": "Stand {{time}} · aktualisiert jede Minute",
      "Background workers": "Hintergrunddienste",
      "running": "läuft",
      "not responding": "reagiert nicht",
      "no heartbeat yet": "noch keine Rückmeldung",
      "last heartbeat {{age}} ago": "letzte Rückmeldung vor {{age}}",
      "up {{age}}": "läuft seit {{age}}",
      "{{n}} cameras in error": "{{n}} Kameras mit Fehler",
      "Workers report after the update is deployed and they have been restarted.": "Die Dienste melden sich, sobald das Update eingespielt und sie neu gestartet wurden.",
      "{{n}} s": "{{n}} s",
      "{{n}} min": "{{n}} min",
      "{{n}} h": "{{n}} h",
      "{{n}} d": "{{n}} T",
      "Teltonika has never connected": "Teltonika war noch nie verbunden",
      "Teltonika offline for {{age}}": "Teltonika seit {{age}} offline",
      "Special-plate rules not fetched for {{age}}": "Sonderkennzeichen-Regeln seit {{age}} nicht abgerufen",
      "{{count}} plate syncs failed (oldest {{age}})": "{{count}} Kennzeichen-Syncs fehlgeschlagen (ältester {{age}})",
      "{{count}} plate syncs waiting for {{age}}": "{{count}} Kennzeichen-Syncs warten seit {{age}}",
      "Camera is not assigned to a gate": "Kamera ist keinem Tor zugeordnet",
      "No passings for {{age}}": "Seit {{age}} keine Durchfahrten",
      "No passings in the last {{days}} days": "Keine Durchfahrten in den letzten {{days}} Tagen",
      "Proximity radius set but no position — app openings fail": "Näherungsradius gesetzt, aber keine Position — Öffnen per App schlägt fehl",
      "No camera and no Teltonika — gate cannot be opened": "Weder Kamera noch Teltonika — Tor kann nicht geöffnet werden",
      "No Teltonika linked": "Kein Teltonika verknüpft",
      "No position set": "Keine Position gesetzt",
      "No problems": "Keine Probleme",
      "{{errors}} errors, {{warnings}} warnings": "{{errors}} Fehler, {{warnings}} Warnungen",
      "{{n}} problems at this site": "{{n}} Probleme an diesem Standort",
      "No problems at this site": "Keine Probleme an diesem Standort",
      "Hide hints": "Hinweise ausblenden",
      "{{n}} hints": "{{n}} Hinweise",
      "{{n}} problems": "{{n}} Probleme",
      "error": "Fehler",
      "warning": "Warnung",
      "info": "Hinweis",
      "Parking": "Parkplatz",
      "Parking (square)": "Parkplatz (eckig)",
      "Underground garage": "Tiefgarage",
      "Multi-storey car park": "Parkhaus",
      "Underground": "Untergeschoss",
      "Car park": "Autoabstellplatz",
      "EV charging": "E-Ladestation",
      "Accessible parking": "Barrierefreies Parken",
      "Staff / reserved": "Personal / reserviert",
      "Secured area": "Gesicherter Bereich",
      "Construction": "Baustelle",
      "Logistics": "Logistik",
      "Bus / coach parking": "Bus-Parkplatz",
      "Park & Ride": "Park & Ride",
      "Bicycle": "Fahrrad",
      "Airport": "Flughafen",
      "Petrol station": "Tankstelle",
      "Building": "Gebäude",
      "Multi-building": "Gebäudekomplex",
      "Office": "Büro",
      "Conference centre": "Konferenzzentrum",
      "Public authority": "Behörde",
      "Retail": "Handel",
      "Supermarket": "Supermarkt",
      "Restaurant / café": "Restaurant / Café",
      "Hotel": "Hotel",
      "Residential": "Wohnanlage",
      "Hospital": "Krankenhaus",
      "Medical centre": "Ärztezentrum",
      "School / university": "Schule / Universität",
      "Sports venue": "Sportstätte",
      "Sports field": "Sportplatz",
      "Event venue": "Veranstaltungsort",
      "Concert hall": "Konzerthaus",
      "Cinema": "Kino",
      "Park / nature": "Park / Natur",
      "Lake / swimming pool": "See / Schwimmbad",
      "Tourism": "Tourismus",
      "None": "Keine",
      "Pick on map": "Auf Karte wählen",
      "Hide map": "Karte ausblenden",
      "Clear position": "Position entfernen",
      "Address not found": "Adresse nicht gefunden",
      "Address search is unavailable": "Adresssuche nicht verfügbar",
      "Search address…": "Adresse suchen…",
      "Search": "Suchen",
      "Click the map at the barrier, or drag the pin. The circle shows the proximity radius.": "Auf der Karte beim Schranken klicken oder den Pin ziehen. Der Kreis zeigt den Näherungsradius.",
      "Name and address of the location": "Name und Adresse des Standorts",
      "Parking areas, their barriers and the Teltonika behind them": "Parkbereiche, ihre Schranken und der zugehörige Teltonika",
      "ANPR cameras per gate — test the connection before saving": "ANPR-Kameras je Tor — Verbindung vor dem Speichern testen",
      "Check everything — nothing is saved before you confirm": "Alles prüfen — gespeichert wird erst nach Bestätigung",
      "Remove": "Entfernen",
      "New camera": "Neue Kamera",
      "new": "neu",
      "Plates to sync": "Zu synchronisierende Kennzeichen",
      "Everything checks out.": "Alles in Ordnung.",
      "The browser blocked the camera window — please allow popups for this site.": "Der Browser hat das Kamerafenster blockiert — bitte Pop-ups für diese Seite erlauben.",
      "Close": "Schließen",
      "Remote session": "Fernzugriff aktiv",
      "Show window": "Fenster anzeigen",
      "End session": "Sitzung beenden",
      "Open the camera's web interface through a temporary tunnel": "Weboberfläche der Kamera über einen temporären Tunnel öffnen",
      "Camera on this Teltonika": "Kamera an diesem Teltonika",
      "Camera {{n}} (port {{port}})": "Kamera {{n}} (Port {{port}})",
      "Enter a custom URL": "Eigene URL eingeben",
      "Pick Teltonika and camera instead": "Stattdessen Teltonika und Kamera wählen",
      "Link a Teltonika to a gate of this area first.": "Verknüpfen Sie zuerst einen Teltonika mit einem Tor dieses Bereichs.",
      "1 new site": "1 neuer Standort",
      "Add a gate first — cameras belong to a gate.": "Bitte zuerst ein Tor anlegen — Kameras gehören zu einem Tor.",
      "Add areas, gates, cameras": "Bereiche, Tore, Kameras hinzufügen",
      "Add camera": "Kamera hinzufügen",
      "Add gate": "Tor hinzufügen",
      "Add parking area": "Parkbereich hinzufügen",
      "Add to site": "Zum Standort hinzufügen",
      "All": "Alle",
      "Areas & gates": "Bereiche & Tore",
      "Assign a Teltonika to a sales partner so their admins can set it up at their own sites.": "Weisen Sie einen Teltonika einem Vertriebspartner zu, damit dessen Admins ihn an eigenen Standorten einrichten können.",
      "Back": "Zurück",
      "Camera": "Kamera",
      "Checking…": "Wird geprüft…",
      "Comment": "Kommentar",
      "Create site": "Standort anlegen",
      "Extend {{name}}": "{{name}} erweitern",
      "Linked to": "Verknüpft mit",
      "New gate": "Neues Tor",
      "New parking area": "Neuer Parkbereich",
      "New parking areas, gates and cameras will be added to {{name}}. Existing ones stay unchanged — edit them on the site page.": "Neue Parkbereiche, Tore und Kameras werden zu {{name}} hinzugefügt. Bestehende bleiben unverändert — bearbeiten Sie diese auf der Standortseite.",
      "New site": "Neuer Standort",
      "Next": "Weiter",
      "No partner assigned": "Kein Partner zugewiesen",
      "Not linked to a gate": "Mit keinem Tor verknüpft",
      "Not reachable": "Nicht erreichbar",
      "Please fix:": "Bitte korrigieren:",
      "Reachable, but login failed": "Erreichbar, aber Anmeldung fehlgeschlagen",
      "Reachable, login works": "Erreichbar, Anmeldung funktioniert",
      "Recorded passings of new cameras start arriving within about an hour.": "Erfasste Durchfahrten neuer Kameras erscheinen nach etwa einer Stunde.",
      "Remove camera": "Kamera entfernen",
      "Remove gate": "Tor entfernen",
      "Review": "Prüfen",
      "Routers": "Router",
      "Search MAC, IP, site…": "MAC, IP, Standort suchen…",
      "Setup": "Einrichtung",
      "Status": "Status",
      "Test connection": "Verbindung testen",
      "Testing…": "Wird getestet…",
      "Unexpected response": "Unerwartete Antwort",
      "empty = global account": "leer = globales Konto",
      "existing": "bestehend",
      "{{n}} existing cameras": "{{n}} bestehende Kameras",
      "{{n}} license plates will be sent to the new cameras": "{{n}} Kennzeichen werden an die neuen Kameras übertragen",
      "{{n}} new cameras": "{{n}} neue Kameras",
      "{{n}} new gates": "{{n}} neue Tore",
      "{{n}} new parking areas": "{{n}} neue Parkbereiche",
      "Administration": "Administration",
      "All sites": "Alle Standorte",
      "Back to dashboard": "Zurück zum Dashboard",
      "Camera URL": "Kamera-URL",
      "Camera password": "Kamera-Passwort",
      "Camera username": "Kamera-Benutzername",
      "Cameras": "Kameras",
      "Cameras without a gate": "Kameras ohne Tor",
      "City": "Ort",
      "Code from the email": "Code aus der E-Mail",
      "Confirm": "Bestätigen",
      "Could not send the code. Please try again.": "Der Code konnte nicht gesendet werden. Bitte erneut versuchen.",
      "Delete permanently?": "Endgültig löschen?",
      "Empty = no GPS check for app openings. 50–5000 m.": "Leer = keine GPS-Prüfung beim Öffnen per App. 50–5000 m.",
      "End admin session": "Admin-Sitzung beenden",
      "Entry": "Einfahrt",
      "Exit": "Ausfahrt",
      "For your security, confirm it's you: we'll email a one-time code to your address.": "Zu Ihrer Sicherheit bestätigen Sie bitte Ihre Identität: Wir senden einen Einmal-Code an Ihre E-Mail-Adresse.",
      "Gate": "Tor",
      "Gates of the same area may share one Teltonika.": "Tore desselben Bereichs können sich einen Teltonika teilen.",
      "Invalid or expired code": "Ungültiger oder abgelaufener Code",
      "Last handshake: {{at}}": "Letzter Handshake: {{at}}",
      "License plates": "Kennzeichen",
      "Loading…": "Wird geladen…",
      "Moving a site to another partner changes who can administer it.": "Ein Wechsel des Partners ändert, wer den Standort verwalten darf.",
      "Must point to the Teltonika of this area (WireGuard address).": "Muss auf den Teltonika dieses Bereichs zeigen (WireGuard-Adresse).",
      "Never connected": "Nie verbunden",
      "No Teltonika": "Kein Teltonika",
      "No Teltonika linked to a gate yet": "Noch kein Teltonika mit einem Tor verknüpft",
      "No gates in this area.": "Keine Tore in diesem Bereich.",
      "No partner": "Kein Partner",
      "No router linked": "Kein Router verknüpft",
      "No sites found.": "Keine Standorte gefunden.",
      "Opener": "Öffner",
      "Opens the barrier": "Öffnet den Schranken",
      "Parking areas": "Parkbereiche",
      "Partner admin": "Partner-Admin",
      "Plate sync records": "Kennzeichen-Sync-Einträge",
      "Platform admin": "Plattform-Admin",
      "Recorded passings": "Erfasste Durchfahrten",
      "Relay": "Relais",
      "Remote access": "Fernzugriff",
      "Remove stored credentials (use the global camera account)": "Gespeicherte Zugangsdaten entfernen (globales Kamerakonto verwenden)",
      "Resend code": "Code erneut senden",
      "Resend in {{s}} s": "Erneut senden in {{s}} s",
      "Sales partner": "Vertriebspartner",
      "Saving…": "Wird gespeichert…",
      "Search name, city, partner…": "Name, Ort, Partner suchen…",
      "Send code": "Code senden",
      "Session until {{time}}": "Sitzung bis {{time}}",
      "Site details": "Standortdaten",
      "Sites": "Standorte",
      "Skip plate sync": "Kennzeichen-Sync überspringen",
      "Street": "Straße",
      "This cannot be undone.": "Dies kann nicht rückgängig gemacht werden.",
      "This gate still has cameras. Move them to another gate or delete them first.": "Diesem Tor sind noch Kameras zugeordnet. Verschieben oder löschen Sie diese zuerst.",
      "Timezone": "Zeitzone",
      "Type the name to confirm:": "Zur Bestätigung den Namen eingeben:",
      "User access grants": "Benutzerberechtigungen",
      "Your account has no administrator access.": "Ihr Konto hat keinen Administratorzugang.",
      "ZIP": "PLZ",
      "free": "frei",
      "not set — global account": "nicht gesetzt — globales Konto",
      "offline": "offline",
      "online": "online",
      "unchanged (set)": "unverändert (gesetzt)",
      "will be deleted together with:": "wird gelöscht, zusammen mit:",
      "{{n}} failed syncs": "{{n}} fehlgeschlagene Syncs",
      "{{n}} pending": "{{n}} ausstehend",
      "{{online}}/{{total}} online": "{{online}}/{{total}} online",
      "— no Teltonika —": "— kein Teltonika —",
      "— no gate —": "— kein Tor —",
      "— none (ezentry only) —": "— keiner (nur ezentry) —",
      "login": "Login",
      "select_area": "Parkfläche auswählen",
      "details": "Details",
      "date_from": "Datum von",
      "date_to": "Datum bis",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "add": "Hinzufügen",
      "Expired": "Abgelaufen",
      "Home": "Home",
      "Area": "Parkfläche",
      "details_for_area": "Details für Parkfläche",
      "Hide": "Verbergen",
      "Show": "Zeigen",
      "Open Gate": "Schranke öffnen",
      "Close Gate": "Schranke schließen",
      "Logged in as": "Angemeldet als",
      "Guest": "Gast",
      "Login": "Login",
      "Select Car Plate": "Kennzeichen",
      "Plate": "Kennzeichen",
      "Save": "Speichern",
      "Save_New_Plate": "Neues Kennzeichen speichern",
      "Logout": "Abmelden",
      "de": "Deutsch",
      "en": "Englisch",
      "Save_success": "Erfolgreich gespeichert",
      "Delete_success": "Erfolgreich gelöscht",
      "Cancel": "Abbrechen",
      "Delete": "Löschen",
      "Confirm_Deletion": "Löschen bestätigen",
      "Delete_question_user": "Zugang entfernen für",
      "Delete_question_plate": "Wollen Sie das Kennzeichen wirklich löschen",
      "Delete_question_user": "Wollen Sie den User wirklich löschen",
      "Dashboard": "Dashboard",
      "Select Site": "Standort wählen",
      "Loading sites...": "Lade Standorte...",
      "Please select a site.": "Bitte wählen Sie einen Standort",
      "no gates": "Keine Schranken",
      "no_cameras": "Keine Kameras",
      "Select Camera": "Kamera auswählen",
      "Getting location": "Standort wird ermittelt…",
      "Too far from gate": "Zu weit vom Schranken entfernt",
      "Location unavailable": "Standort nicht verfügbar",
      "Location access blocked": "Standortzugriff gesperrt",
      "Re-enable location hint": "Standort benötigt HTTPS. Bei HTTPS: Schloss-Symbol → Website-Einstellungen → Standort → Zulassen",
      // Gate management
      "Gates": "Schranken",
      "Proximity": "Standort zum Öffnen erforderlich",
      "No coordinates set": "⚠ Keine Koordinaten gesetzt — Support kontaktieren",
      "Proximity applies to gate openers only. Site managers can always open.": "Gilt nur für manuelles Öffnen. Site Manager können immer öffnen.",
      "Gate updated.": "Schranke aktualisiert.",
      "Camera updated.": "Kamera aktualisiert.",
      "Failed to update gate": "Schranke konnte nicht aktualisiert werden",
      "Failed to update camera": "Kamera konnte nicht aktualisiert werden",
      "Gate name": "Schrankenname",
      "Direction": "Richtung",
      "entry": "Einfahrt",
      "exit": "Ausfahrt",
      "Latitude": "Breitengrad",
      "Longitude": "Längengrad",
      "Proximity radius (m)": "Näherungsradius (m)",
      "Teltonika": "Teltonika",
      "Is opener": "Öffner",
      "No plate sync": "Kein Kennzeichen-Sync",
      "opener": "Öffner",
      "no sync": "kein Sync",
      "sync_status_title": "Sync-Status",
      "deleted_still_active_title_one": "{{count}} gelöschtes Kennzeichen kann noch einfahren",
      "deleted_still_active_title_other": "{{count}} gelöschte Kennzeichen können noch einfahren",
      "deleted_still_active_hint": "Das Tor hat die Löschung noch nicht bestätigt (vermutlich nicht erreichbar). Wir versuchen es automatisch weiter.",
      "sync_not_synced_one": "{{count}} Kennzeichen nicht synchronisiert",
      "sync_not_synced_other": "{{count}} Kennzeichen nicht synchronisiert",
      "last try": "letzter Versuch",
      "Checking session...": "Session prüfen...",
      "Send Code": "Code zuschicken",
      "Enter the 6-digit code": "6-stelligen Code eingeben",
      "Back": "zurück",
      "Areas": "Parkflächen",
      "Area name": "Name der Parkfläche",
      "Available spaces": "Verfügbare Plätze",
      "spaces": "Plätze",
      "Icon": "Symbol",
      "No areas found.": "Keine Parkflächen vorhanden.",
      "Area updated.": "Parkfläche aktualisiert.",
      "Failed to update area": "Parkfläche konnte nicht aktualisiert werden",
      "No areas found for this site": "Für diesen Standort wurden keine Parkplätze gefunden",
      "Loading...": "Lädt...",
      "Licenses": "Kennzeichen",
      "Used": "vergeben",
      "Opening": "Wird geöffnet",
      "Opened": "Geöffnet",
      "Error": "Fehler",
      "Open": "Öffnen",
      "Note": "Anmerkung",
      "note_gdpr_hint": "Personenbezogene Daten in diesem Feld (z. B. Namen) sind DSGVO-relevant. Nur eintragen, wenn eine rechtliche Grundlage vorliegt.",
      "User Management": "Benutzerverwaltung",
      "Enter email": "E-Mail Adresse eingeben",
      "Enter user's name": "Usernamen eingeben",
      "Role": "Rolle",
      "Scope": "Bereich",
      "Site": "Standort",
      "Grant Authorization": "Berechtigung erteilen",
      "Existing Users": "Benutzer",
      "No users found": "Keine Benutzer gefunden",
      "Valid From": "Gültig von",
      "Valid Until": "Gültig bis (optional)",
      "Tap to open": "zum Öffnen tippen",
      "LoginText": "Bitte geben Sie den Code ein, den Sie per Mail erhalten haben.",
      "Enter your email": "E-Mail-Adresse eingeben",
      "add new": "hinzufügen",
      "site_manager for area not allowed": "Die Rolle 'site_manager' kann auf Parkflächen nicht vergeben werden.",
      "Please select an area for the user": "Bitte wählen Sie eine Parkfläche aus.",
      "Please enter an email": "Bitte E-Mail Adresse eingeben.",
      "Please enter a valid email address": "Bitte eine gültige E-Mail-Adresse eingeben.",
      "too_much_devices": "Sie dürfen sich nicht auf mehr als einem Geräte einloggen. Bitte kontaktieren Sie Ihren Administrator.",
      "Search by name or email": "Suche nach Name oder Email",
      "Detailed Statistics": "Detaillierte Statistik",
      "Showing plates per hour for every area.": "Sehen Sie Kennzeichen pro Stunde pro Parkfläche",
      "All areas": "Alle Parkflächen",
      "Statistics": "Statistiken",
      "Open camera": "Kamera anzeigen",
      "site_manager": "Bereichs-Manager",
      "gate_opener": "Tor Bediener",
      "platform_admin": "Plattform-Admin",
      "partner_admin": "Partner-Admin",
      "Click for details": "Für Details klicken",
      "click_hour_hint": "Balken im Diagramm antippen um Details zu laden",
      "insights_title": "Auswertung",
      "insights_passings": "Durchfahrten",
      "insights_unique": "Verschiedene Kennzeichen",
      "insights_peak_avg": "/ Tag in dieser Stunde",
      "day_abbr": "T",
      "insights_auth_rate": "Zutrittsrate",
      "insights_peak_hour": "Stoßzeit",
      "insights_avg_day": "Ø / Tag",
      "insights_typically_day": "typisch / Tag",
      "insights_top_denied": "Top Abgewiesen",
      "insights_top_allowed": "Top Erlaubt",
      "insights_area_breakdown": "Bereiche",
      "insights_week": "Woche",
      "insights_month": "Monat",
      "insights_quick_add_title": "Kennzeichen hinzufügen",
      "insights_quick_add_note": "Notiz (optional)",
      "insights_quick_add_areas": "Zu Bereichen hinzufügen",
      "insights_quick_add_success": "Kennzeichen erfolgreich hinzugefügt",
      "insights_no_data": "Keine Daten für diesen Zeitraum",
      "plate_already_exists": "Dieses Kennzeichen existiert bereits in diesem Bereich",
      "fuzzy_match_hint": "Möglicher Treffer — Kamera hat \"{{raw}}\" gelesen, vermutlich ein Lesefehler",
      "pss_match_hint": "Automatisch geöffnet als Einsatzfahrzeug (Polizei, Feuerwehr, ...) — kein hinterlegtes Kennzeichen",
      "export_csv": "CSV exportieren",
      "include_denied": "Abgewiesene einschließen",
      "export_failed": "Export fehlgeschlagen. Bitte erneut versuchen.",
      "export_tab": "Export",
      "update_available": "Eine neue Version von ezentry ist verfügbar.",
      "update_reload": "Neu laden",
      "update_later": "Später",
      "export_plates_title": "Kennzeichen",
      "export_plates_hint": "Alle Kennzeichen einer Parkfläche als CSV-Datei herunterladen: Kennzeichen, gültig von, gültig bis, Notiz, Kategorien und Hinzufügedatum. Mehrere Kategorien sind durch \" | \" getrennt.",
      "export_select_area": "Parkfläche wählen…",
      "export_passings_title": "Durchfahrten (Statistik)",
      "export_passings_hint": "Durchfahrten Ihrer Schranken für einen Zeitraum herunterladen. Das geht auch auf der Statistik-Seite.",
      "export_range_hint": "Max. 1 Jahr pro Export",
      "Authorized": "Erlaubt",
      "Unauthorized": "Verweigert",
      // Gate control
      "Opening...": "Öffne...",
      "Retry": "Erneut versuchen",
      // Plate form
      "new_category": "Kategorie",
      "Clear filters": "Filter zurücksetzen",
      "search_plates_placeholder": "Kennzeichen suchen...",
      "No plates match your filter": "Keine Kennzeichen entsprechen dem Filter",
      "no_plate_found_for": "Kein Kennzeichen gefunden für \"{{plate}}\".",
      "Add plate": "Kennzeichen hinzufügen",
      "new_short": "Neu",
      "No plates in this area yet.": "Noch keine Kennzeichen in dieser Parkfläche.",
      "Add first plate": "Erstes Kennzeichen hinzufügen",
      // Statistics
      "Loading statistics...": "Statistiken laden...",
      "Site Overview": "Gesamter Standort",
      // Areas / Details
      "Area not found": "Parkfläche nicht gefunden",
      // User management
      "Email": "E-Mail",
      "Name": "Name",
      "Creating...": "Erstelle...",
      // Login
      "Wrong code": "Falscher Code",
      "Verification failed": "Überprüfung fehlgeschlagen",
      "Access denied": "Zugang verweigert",
      "Back to login": "Zurück zur Anmeldung",
      // Admin / Cameras
      "Select Area": "Parkfläche auswählen",
      "Select Gate": "Schranke auswählen",
      "Edit site": "Standort bearbeiten",
      "Add area": "Bereich hinzufügen",
      "Edit area": "Bereich bearbeiten",
      // What's New modal
      "gdpr_title": "Datenschutzhinweise",
      "gdpr_link": "Datenschutz",
      "whats_new_title": "Was ist neu",
      "whats_new_close": "Verstanden",

      "whats_new_1_8_title": "CSV-Export & Sammellöschung",
      "whats_new_1_8_item1": "Statistiken als CSV-Datei exportieren – für weitere Auswertung oder Berichte",
      "whats_new_1_8_item2": "Mehrere Kennzeichen gleichzeitig löschen — auch eine ganze Kategorie wie 'Abgelaufen'",
      "whats_new_1_8_item3": "Behebt doppelte Kennzeichen durch unterschiedliche Schreibweise (z. B. W-1234A vs. W1234A), sowie weitere Fehlerbehebungen",
      "whats_new_1_8_item4": "Android App 'ezentry' im Google Play Store erhältlich",
      "whats_new_1_10_title": "Mehr Symbole, Warnung bei gelöschten Kennzeichen & Rund-um-die-Uhr-Überwachung",
      "whats_new_1_10_item1": "Mehr Symbole für Parkbereiche — z. B. Tiefgarage, Parkhaus, Sportstätte, Veranstaltungsort, Hotel",
      "whats_new_1_10_item2": "Ist ein gelöschtes Kennzeichen an einem Tor noch aktiv (z. B. weil das Tor kurz nicht erreichbar war), sehen Sie das jetzt sofort im Parkbereich",
      "whats_new_1_10_item3": "Rund-um-die-Uhr-Überwachung: Wir werden automatisch benachrichtigt, wenn ein Tor die Verbindung verliert, und können reagieren — oft bevor es Ihnen auffällt",
      "whats_new_1_9_title": "Sammelbearbeitung, Sync-Status & Sonderkennzeichen",
      "whats_new_1_9_item1": "Mehrere Kennzeichen gleichzeitig bearbeiten — z. B. Gültigkeitsdaten für alle ausgewählten Kennzeichen ändern",
      "whats_new_1_9_item2": "Neuer Sync-Status zeigt, ob Kennzeichen bereits an die Schranke übertragen wurden",
      "whats_new_1_9_item3": "Sonderkennzeichen (z. B. Polizei, Rettung, Taxi) lassen sich in den Standort-Einstellungen pro Standort ein- und ausschalten",
      "whats_new_1_9_item4": "Mehr Sicherheit bei Berechtigungen, korrekter CSV-Export für deutsche Excel-Versionen und weitere Fehlerbehebungen",
      "whats_new_1_9_item5": "Kennzeichenliste nach Hinzufügedatum gruppieren — auf einen Blick sehen, was heute, diese Woche oder diesen Monat dazugekommen ist",

      "whats_new_1_7_title": "Schranken, Insights & Design",
      "whats_new_1_7_item1": "GPS-Standortprüfung beim Öffnen von Schranken — stellt sicher, dass Schranken nur vor Ort geöffnet werden können",
      "whats_new_1_7_item2": "Neues Insights-Panel: wöchentliche & monatliche Durchfahrten, Spitzenstunde, Top-Kennzeichen, Aufschlüsselung nach Bereichen",
      "whats_new_1_7_item3": "Überarbeitetes Design: klarere Seiten-/Karten-Hierarchie, verbesserter Dunkelmodus",

      "whats_new_1_6_title": "Kennzeichen-Überblick & Design",
      "whats_new_1_6_item1": "Sortieren und gruppieren Sie Kennzeichen nach Kategorie, Ablaufdatum oder Kennzeichen, um stets den Überblick zu behalten",
      "whats_new_1_6_item2": "Dunkel-Modus: Automatische Anpassung an Ihre Systemeinstellungen oder wählen Sie selbst, ob die App dunkel oder hell angezeigt wird",
      "whats_new_1_6_item3": "Statistik-Details: prüfen Sie, welchen Kennzeichen die Durchfahrt erlaubt bzw. verboten wurde",

      "whats_new_1_5_title": "Standorteinstellungen",
      "whats_new_1_5_item1": "Parkflächen-Details anpassen (Parkplatz-Anzahl, Name, Symbol)",
      "whats_new_1_5_item2": "Benutzerverwaltung für den gewählten Standort",
      "whats_new_1_5_item3": "Kategorien hinzufügen, ändern, löschen",

      "whats_new_1_4_title": "Benutzerdefinierte Kennzeichenkategorien",
      "whats_new_1_4_item1": "Erstellen Sie benutzerdefinierte Kategorien pro Standort und ordnen Sie Kennzeichen zu.",
      "whats_new_1_4_item2": "Filtern und gruppieren Sie Kennzeichen nach Kategorie.",

      "whats_new_1_3_title": "Statistik",
      "whats_new_1_3_item1": "Sehen Sie erlaubte und verweigerte Durchfahrten an Ihren Schranken",
      "whats_new_1_3_item2": "Eine Detailstatistik zeigt die Daten aufgeschlüsselt pro Parkfläche und zurück für die letzen 7 Tage",
      // Site settings / categories
      "Site settings": "Standorteinstellungen",
      "Statistics details": "Statistik Details",
      "Categories": "Kategorien",
      "Users": "Benutzer",
      "Special Plates": "Spezielle Kennzeichen",
      "Austria": "Österreich",
      "pss_label_police": "Bundespolizei (BP-)",
      "pss_label_firebrigade": "Feuerwehr (FW-)",
      "pss_label_rettungsdienst": "Rettungsdienste Wien (W-XXXX-RD / W-XXXX-MA)",
      "pss_label_taxi": "Taxi (…TX)",
      "pss_label_army": "Bundesheer (BH-)",
      "pss_label_post": "Österreichische Post (PT-)",
      "Vehicles matching an enabled category open this site's gates automatically, without needing to be enrolled as a plate.": "Fahrzeuge, die einer aktivierten Kategorie entsprechen, öffnen die Schranken dieses Standorts automatisch, ohne als Kennzeichen hinterlegt sein zu müssen.",
      "Changes can take up to 30 minutes to reach the barrier.": "Änderungen können bis zu 30 Minuten benötigen, bis sie bei der Schranke ankommen.",
      "No special plate categories available.": "Keine speziellen Kennzeichenkategorien verfügbar.",
      "Failed to load special plates.": "Spezielle Kennzeichen konnten nicht geladen werden.",
      "Failed to update rule.": "Regel konnte nicht aktualisiert werden.",
      "New category name": "Neuer Kategoriename",
      "No categories yet.": "Noch keine Kategorien.",
      "plates": "Kennzeichen",
      "Delete Category": "Kategorie löschen",
      "Delete category": "Kategorie löschen",
      "This category is used for": "Diese Kategorie wird von",
      "Plates will not be deleted, only deassociated.": "Kennzeichen werden nicht gelöscht, nur die Zuweisung wird entfernt.",
      "Category updated.": "Kategorie aktualisiert.",
      "Category created.": "Kategorie erstellt.",
      "Category deleted.": "Kategorie gelöscht.",
      "Failed to update category": "Kategorie konnte nicht aktualisiert werden",
      "Failed to create category": "Kategorie konnte nicht erstellt werden",
      "Failed to delete category": "Kategorie konnte nicht gelöscht werden",
      // User management (new strings)
      "Manage users": "Benutzer verwalten",
      "User created successfully!": "Benutzer erfolgreich erstellt!",
      "Failed to load users": "Benutzer konnten nicht geladen werden",
      "Enter an email address and role to grant someone access to this site.": "E-Mail und Rolle eingeben, um Zugang zu diesem Standort zu gewähren.",
      "I confirm I have the legal basis to add this person to the system.": "Ich bestätige, dass ich die Berechtigung habe, diese Person hinzuzufügen.",
      "Please confirm you have the legal basis to add this person.": "Bitte bestätigen Sie, dass Sie die Berechtigung zum Hinzufügen haben.",
      "Details carried over from the dashboard — review and click Grant Authorization to complete.": "Daten vom Dashboard übernommen – bitte prüfen und auf 'Berechtigung erteilen' klicken.",
      // User settings
      "Settings": "Einstellungen",
      "Appearance": "Erscheinungsbild",
      "theme_system": "System",
      "theme_light": "Hell",
      "theme_dark": "Dunkel",
      // Plate sorting & grouping
      "sort_by": "Sortierung",
      "sort_plate": "A–Z",
      "sort_created": "Hinzugefügt",
      "sort_expiry": "Ablaufdatum",
      "view_group":         "Gruppierung",
      "group_by_category":  "Nach Kategorie",
      "group_by_expiry":    "Nach Ablaufdatum",
      "group_by_added":     "Nach Hinzufügedatum",
      "added_today":        "Heute hinzugefügt",
      "added_last_7_days":  "Letzte 7 Tage",
      "added_last_30_days": "Letzte 30 Tage",
      "added_older":        "Älter",
      "sync_filter_chip":   "Nicht synchronisiert",
      "sync_filter_hint":   "Nur nicht synchronisierte Kennzeichen anzeigen",
      "uncategorized":      "Ohne Kategorie",
      "expiry_this_month":  "Diesen Monat",
      "expiry_this_quarter":"Dieses Quartal",
      "expiry_later":       "Später",
      "expiry_never":       "Kein Ablaufdatum",
      // Bulk plate selection
      "select_multiple": "Mehrere auswählen",
      "done_selecting": "Auswahl beenden",
      "select_all_in_group": "Alle in dieser Gruppe auswählen",
      "deselect_all_in_group": "Auswahl in dieser Gruppe aufheben",
      "plates_selected_one": "{{count}} Kennzeichen ausgewählt",
      "plates_selected_other": "{{count}} Kennzeichen ausgewählt",
      "confirm_bulk_delete_one": "Dieses Kennzeichen löschen?",
      "confirm_bulk_delete_other": "{{count}} Kennzeichen löschen?",
      "and_n_more_one": "…und {{count}} weitere",
      "and_n_more_other": "…und {{count}} weitere",
      "Delete_success_bulk_one": "Kennzeichen gelöscht",
      "Delete_success_bulk_other": "{{count}} Kennzeichen gelöscht",
      "bulk_edit_title": "Daten ändern",
      "bulk_edit_hint_one": "Wählen Sie, welches Datum für das ausgewählte Kennzeichen geändert werden soll. Nur angehakte Felder werden aktualisiert.",
      "bulk_edit_hint_other": "Wählen Sie, welches Datum für alle {{count}} ausgewählten Kennzeichen geändert werden soll. Nur angehakte Felder werden aktualisiert.",
      "plates_updated_bulk_one": "Kennzeichen aktualisiert",
      "plates_updated_bulk_other": "{{count}} Kennzeichen aktualisiert",
      "plates_skipped_invalid_range_one": "{{count}} Kennzeichen übersprungen — neues Datum läge vor dem anderen Datum: {{plates}}",
      "plates_skipped_invalid_range_other": "{{count}} Kennzeichen übersprungen — neues Datum läge vor dem jeweils anderen Datum: {{plates}}"
    }
  }
};
const savedLng = getLanguage();
i18n.use(initReactI18next).init({
  resources,
  lng: savedLng,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
